exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tree-search-block #tree-search {\n  float: left;\n  width: 175px; }\n\n.tree-search-block .form-group {\n  padding-left: 0px; }\n\n.tree-search-block form .form-block, .tree-search-block .form .form-block {\n  margin-top: -10px; }\n\n.tree-search-block .select {\n  float: left; }\n\n.tree-search-block .search-type {\n  font-size: 10px;\n  font-family: 'Metropolis';\n  width: 110px; }\n\n.dps-tree-container {\n  padding-left: 10px;\n  height: calc(100vh - 180px);\n  overflow: hidden; }\n\n.dps-tree-container:hover {\n  overflow: auto; }\n\n.dps-tree-holder {\n  border-right: 1px solid #EEEEEE;\n  margin-left: 20px;\n  height: calc(100vh - 180px);\n  overflow: hidden; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/dataprotection-tree/tree-holder/tree-holder.scss
// module id = S8G9
// module chunks = 0